import React from "react";
import TicketsDetailsReply from "../../components/tickets-details-reply/TicketsDetailsReply";

const TicketDetailsEmailReply = () => {
  return <TicketsDetailsReply />;
};

export default TicketDetailsEmailReply;
